import { useQuery } from '@apollo/client';
import React, { memo } from 'react';
import get from 'lodash/get';
import { getCountryCodes } from '@xbcb/ui-utils';
import { getOneQueryLite, getRecordFromResponse } from '@xbcb/shared-queries';
import { getRecordType } from '@xbcb/core';
import { addressesFields } from '@xbcb/party-queries';
import { RecordType } from '@xbcb/shared-types';
import { StyledParagraph } from './styles';

type AddressSummaryProps = {
  recordId: string;
};

const AddressSummary = ({ recordId }: AddressSummaryProps) => {
  const countryCodes = getCountryCodes();

  const recordType = getRecordType(recordId) as RecordType; // getRecordType returns string type right now.

  const getQuery = getOneQueryLite({
    queryName: 'getOne',
    recordName: recordType,
    fields: '...addressesFields',
    fragments: addressesFields,
  });

  const queryResponse = useQuery(getQuery, {
    variables: { id: recordId },
  });

  const record = getRecordFromResponse(queryResponse, 'get', recordType);
  const {
    address = '',
    countryCode = '',
    stateCode = '',
    postalCode = '',
    city = '',
  } = record?.addresses?.mailing || record?.addresses?.physical || {};

  const stateDisplay =
    stateCode && countryCode === 'US'
      ? stateCode
      : get(countryCodes, [countryCode, 'subdivision', stateCode, 'name']) ??
        '';

  const addressString = `${address} ${city} ${stateDisplay} ${
    countryCode === 'US'
      ? countryCode
      : get(countryCodes, [countryCode, 'name']) ?? ''
  } ${postalCode}`;

  if (!addressString.trim()) return null;

  return <StyledParagraph>{addressString}</StyledParagraph>;
};

export default memo(AddressSummary);
